import instoreManageCardsModal from './instoreSMSNumberModal';

export default instoreManageCardsModal;
